// extracted by mini-css-extract-plugin
export default {"staticPage":"staticPage___a4498482eab3f589ee25","section":"section___bbf70e0956c644c5d27c","title":"title___c9992089922530492759","description":"description___cd97071b25b080d0684b"};